import { ptToRem } from "$global-providers/mui-provider/pixel-rem-calculators";
import type { TypographyOptions } from "@material-ui/core/styles/createTypography";

// TODO: All the sizes in his file are not a11y compliant - must convert to rems
export const TYPOGRAPHY = {
  fontSize: 14,
  fontFamily: "NotoSans Regular, Helvetica, Arial, sans-serif",
  fontRegular: "NotoSans Regular",
  fontBold: "NotoSans Bold",
  h1: {
    fontSize: 36,
    fontWeight: "bold",
    color: "inherit",
  },
  h2: {
    fontSize: 30,
    fontWeight: "bold",
    color: "inherit",
  },
  h3: {
    fontSize: 24,
    fontWeight: "bold",
    color: "inherit",
  },
  h4: {
    fontSize: 20,
    fontWeight: "bold",
    color: "inherit",
  },
  h5: {
    fontSize: 18,
    fontWeight: 700,
    color: "inherit",
  },
  subtitle1: {
    fontSize: 16,
    fontWeight: 400,
    color: "inherit",
    lineHeight: 1.75,
  },
  subtitle2: {
    fontSize: 14,
    fontWeight: 400,
    color: "inherit",
    lineHeight: 1.57,
  },
  h6: {
    // DEPRECATED - to be removed
    fontSize: `${ptToRem(16)}rem`,
    fontWeight: "bold",
    color: "inherit",
  },
  body1: {
    fontSize: 16,
    color: "inherit",
  },
  body2: {
    fontSize: 14,
    color: "inherit",
  },

  button: {
    fontSize: 14,
    fontWeight: 600,
    lineHeight: "19px",
    textTransform: "none",
  },
} satisfies TypographyOptions & { fontRegular: string; fontBold: string };
